import { OppButton } from '../ui/control';
import { Link } from 'react-router-dom';
import { Settings, ChevronRight, LogOut } from 'lucide-react';

interface OppProfileFooterActionsProps {
  settingsLabel: string;
  signOutLabel: string;
  onSignOut: () => Promise<void> | void;
}

export function OppProfileFooterActions({ settingsLabel, signOutLabel, onSignOut }: OppProfileFooterActionsProps) {
  return (
    <div className="space-y-2 border-t border-[hsl(var(--opp-border))] pt-4 pb-8">
      <Link
        to="/settings"
        className="flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium text-[hsl(var(--opp-ink))] transition-colors hover:bg-[hsl(var(--opp-surface-raised))]"
      >
        <Settings className="h-4 w-4 text-[hsl(var(--opp-muted))]" />
        {settingsLabel}
        <ChevronRight className="ml-auto h-4 w-4 text-[hsl(var(--opp-muted))]" />
      </Link>
      <OppButton
        onClick={onSignOut}
        className="flex w-full items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium text-[hsl(var(--opp-danger-fg))] transition-colors hover:bg-[hsl(var(--opp-danger-bg))]"
      >
        <LogOut className="h-4 w-4" />
        {signOutLabel}
      </OppButton>
    </div>
  );
}
